import * as React from 'react';

import PropTypes from 'prop-types';

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

function Header({ siteTitle }) {
  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/#services' },
    { name: 'About Us', href: '/#about' },
    { name: 'Contact Us', href: '/#contact' },
  ];

  return (
    <header className=" z-10 w-full border-b-2 border-primary bg-primary">
      <Disclosure as="nav">
        {({ open }) => (
          <div>
            <div className="mx-auto max-w-7xl">
              <div className="relative mx-auto flex items-center justify-between px-5 py-2">
                {/* Menu Bar */}
                <div className="flex flex-1">
                  {/* Logo Image */}
                  <Link to="/">
                    <StaticImage
                      src="../images/bailey-tech-logo.png"
                      quality={95}
                      formats={['AUTO', 'WEBP']}
                      alt={siteTitle}
                      className="h-auto w-[250px] max-w-[300px]  sm:w-full"
                      loading="eager"
                    />
                  </Link>

                  {/* Desktop menu button */}
                  <div className="hidden flex-1 items-center justify-end pr-20 lg:flex">
                    <div className="flex sm:gap-x-10">
                      {navigation.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          className="font-medium text-white   sm:text-lg md:text-xl lg:text-2xl"
                          aria-current={item.current ? 'page' : undefined}
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Mobile menu button */}
                <div className="mr-5 flex w-1/12 text-white lg:hidden">
                  <DisclosureButton>
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-8 w-8" aria-hidden="true" />
                    ) : (
                      <Bars3Icon
                        className="block h-10 w-10 "
                        aria-hidden="true"
                      />
                    )}
                  </DisclosureButton>
                </div>
              </div>
            </div>

            {/* Mobile menu dropdown */}
            <DisclosurePanel className="absolute z-10 flex w-full  justify-end border-t-2 bg-white p-5 text-right lg:hidden ">
              <div className="flex flex-col gap-y-5">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="block rounded-md text-2xl font-medium text-gray-500 hover:text-gray-900 "
                    aria-current={item.current ? 'page' : undefined}
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </DisclosurePanel>
          </div>
        )}
      </Disclosure>
    </header>
  );
}

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
